<style lang="scss">
@import './pie-move.scss';
</style>
<template>
  <div class="app-pie">
    <div class="pie-move-charts">
      <Spin v-if="spinShow" fix>
        <Icon
          v-show="lodingInfo === this.$t('common.loading')"
          type="ios-loading"
          size='18'
          class="demo-spin-icon-load"></Icon>
        <div>{{ lodingInfo }}</div>
      </Spin>
      <Spin v-else-if="errorSpin" fix>
        <Icon type="md-close" size="18" color="#ff5500"></Icon>
        <div style="color: #ff5500;">{{ $t('common.errorTip') }}</div>
      </Spin>
      <div
        class="nodata-notify"
        v-if="noData">{{ $t('common.nodata') }}</div>
      <div
        class="legend-note"
        v-if="!noData">{{ legendNote }}</div>
      <ul
        class="legend-table">
        <li
          class="legend-item"
          v-for="(each, index) in legendTableData" :key="index">
          <span class="legend-item-icon"
            :style="{ backgroundColor: legendColor[index] }"></span>
          <span class="legend-item-name">{{ each.name }}</span>
          <span class="legend-item-ratio">{{ each.per }}%</span>
          <span class="legend-item-value">{{ each.value }}{{ $t('sceneAnalysis.sceneDis.unit') }}</span>
        </li>
      </ul>
      <div
        class="static-title"
        v-if="showStaticTitle && !noData">
        <div class="static-title-volume">{{ totalVisit | numberSeparator  }}</div>
        <div class="static-title-text">{{ $t('sceneAnalysis.totalVisit') }}</div>
      </div>
      <div class="pie-move-charts-c" ref='piearea'>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from 'echarts';
import numberSeparator from '../../filters/number-separator';

export default {
  data() {
    return {
      myChart: '',
      spinShow: true, // 图表加载状态显示/隐藏
      noData: false, // 没有数据的状况控制
      errorSpin: false, // 数据加载失败状态显示/隐藏
      lodingInfo: this.$t('common.loading'), // 加载文字
      showStaticTitle: true,
      legendTableData: [],
      legendColor: ['#2db7f5', '#7ec856', '#f9bf00', '#808bc6', '#5d6977', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
    };
  },
  props: {
    // currentTab: String,
    legendNote: {
      type: String,
      default: '',
    },
    totalVisit: {
      type: String / Number,
      default: '--',
    },
    // legendData: Array,
    // seriesData: Array,
  },
  methods: {
    initChart(legendData, seriesData) {
      const self = this;
      self.legendTableData = legendData;
      const option = {
        // title: {
        //   text: '334,343',
        //   subtext: this.$t('sceneAnalysis.totalVisit'),
        //   textAlign: 'center',
        //   x: '20%',
        //   y: 'center',
        //   show: self.showStaticTitle,
        // },
        tooltip: {
          trigger: 'item',
          formatter: a => `${a.seriesName}<br>${a.data.name}: ${a.data.value} (${a.percent}%)`,
        },
        // legend: {
        //   orient: 'vertical',
        //   left: '70%',
        //   top: 'middle',
        //   align: 'left',
        //   type: 'scroll',
        //   data: legendData,
        //   formatter: (name) => {
        //     let index = 0;
        //     legendData.forEach((each, i) => {
        //       if (each.name === name) {
        //         index = i;
        //       }
        //     });
        //     const visitUnit = this.$t('sceneAnalysis.sceneDis.unit');
        //     const nm = legendData[index].name;
        //     const per = legendData[index].per;
        //     const v = legendData[index].value;
        //     return `${nm}${per}%${v}${visitUnit}`;
        //   },
        // },
        color: self.legendColor,
        series: [
          {
            name: '场景分布',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            legendHoverLink: false,
            label: {
              normal: {
                show: false,
                position: 'center',
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '15',
                  fontWeight: 'bold',
                },
                formatter: (v) => {
                  const text = v.name;
                  return text.length < 6
                    ? text
                    : `${text.slice(0, 6)}\n${text.slice(6)}`;
                },
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            center: ['20%', '50%'],
            data: seriesData,
          },
        ],
      };
      if (self.$refs.piearea !== null) {
        self.myChart = echarts.init(self.$refs.piearea);
        self.myChart.setOption(option);
        self.myChart.on('mouseover', () => {
          self.showStaticTitle = false;
        });
        self.myChart.on('mouseout', () => {
          self.showStaticTitle = true;
        });
        self.myChart.on('legendselected', () => {
          self.showStaticTitle = false;
        });
      }
    },
    clearData() {
      if (this.myChart) this.myChart.dispose();
      this.spinShow = true; // 图表加载状态显示/隐藏
      this.lodingInfo = this.$t('common.loading'); // 加载文字
      this.errorSpin = false;
      this.noData = false;
      this.legendTableData = [];
    },
    myChartResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    },
  },
  filters: {
    numberSeparator,
  },
  mounted() {
    window.addEventListener('resize', this.myChartResize, false);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.myChartResize, false);
    if (this.myChart) {
      this.myChart.dispose();
    }
  },
};
</script>
